import { render, staticRenderFns } from "./newGallery.vue?vue&type=template&id=6f11878a&scoped=true"
import script from "./newGallery.vue?vue&type=script&lang=js"
export * from "./newGallery.vue?vue&type=script&lang=js"
import style0 from "./newGallery.vue?vue&type=style&index=0&id=6f11878a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f11878a",
  null
  
)

export default component.exports